import { Link } from 'gatsby';
import React from 'react';

import { COLORS } from '../../constants/colors';
import CourierPartnerships from '../Global/CourierPartnerships';
import PartnershipsBackButton from './PartnershipsBackButton';

const PartnershipsNav = ({ colors = {}, open, setOpen }) => {
  return (
    <div className="partnerships-nav">
      <PartnershipsBackButton
        backgroundColor={colors.backButtonBackground}
        color={colors.backButton}
        open={open}
      />
      <Link className="partnerships-nav__logo" to="/partnerships/">
        <CourierPartnerships fill={open ? COLORS.licorice : colors.main} />
      </Link>
    </div>
  );
};

export default PartnershipsNav;
